export default "__VITE_PUBLIC_ASSET__82c028d3__"